import React, { useContext } from 'react';
import {
    Stepper,
    Step,
    StepLabel,
    Box,
    Typography,
    StepConnector,
} from '@mui/material';
import { styled } from '@mui/system';
import ProductCard from '../../../composed/ProductCard/ProductCard';
import Check from '@mui/icons-material/Check';
import { isMobile, isDesktop, isIpad } from '../../../global/ScreenSizeHelper'
import { OnTheMenuDataContext } from '../../../context-api/OnTheMenuDataProvider';

// Optional: transform keys like "main_course" => "Main Course"
const TextTransformation = (text) =>
    text.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

// Optional: navy blue icon style
const navyBlue = '#001F3F';

const CustomStepIcon = (props) => {
    const { active, completed, icon } = props;

    return (
        <Box
            sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: completed || active ? navyBlue : '#ccc',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 14,
            }}
        >
            {completed ? <Check fontSize="small" /> : icon}
        </Box>
    );
};

// Optional: custom connector to fix vertical line alignment
const CustomConnector = styled(StepConnector)(({ theme }) => ({
    marginLeft: '12px',
    '& .MuiStepConnector-line': {
        borderLeftWidth: 0,
        minHeight: 20,
        borderColor: '#ccc',
    },
}));


const productsAtThisStepNumber = (stepLabel, newCartItems) => {
    const products = (newCartItems?.mealItems?.filter((item) => item.product_category === stepLabel) || []);
    let number = 0;
    products.forEach((item) => {
        number += item.selectedQuantity;
    })
    return number;
}





const ProductVerticalStepper = ({ ProductListObject, mealType, }) => {

    const { cartItems,
        getMealOffering
    } = useContext(OnTheMenuDataContext)


    const stepKeys = Object.keys(ProductListObject || {}).filter((key) => {
        const allowedProducts = getMealOffering()[key];
        if (!allowedProducts) {
            return false;
        }
        return true;
    });



    return (
        <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
            <Stepper
                orientation="vertical"
                nonLinear
                activeStep={-1}
                sx={{
                    '& .MuiStepConnector-line': {
                        minHeight: '0px', // reduce length of vertical lines
                    },
                    '& .MuiStep-root': {
                        paddingBottom: 0, // reduce step spacing
                    },
                    '& .MuiStep-vertical > div': {
                        marginLeft: '12px',
                        borderLeft: '2px solid lightgray'
                    },
                    '& .MuiStepLabel-root': {
                        marginBottom: 0, // tighten label layout
                        marginLeft: isMobile ? '5px' : '',
                    },
                }}
            >
                {stepKeys.map((el, index) => {
                    const allowedProducts = getMealOffering()[el];
                    return (
                        <Step key={el}
                            expanded
                            completed={productsAtThisStepNumber(el, cartItems) > 0}
                            id={el}
                        >
                            <StepLabel
                                StepIconComponent={({ completed, active }) => CustomStepIcon({ completed, icon: index + 1, active })}

                                optional={
                                    productsAtThisStepNumber(el, cartItems) > 0 ? (
                                        <Typography variant="caption" color={navyBlue}>
                                            {`${productsAtThisStepNumber(el, cartItems)} Selected`}
                                        </Typography>
                                    ) : null
                                }

                                sx={{
                                    '& .MuiStepLabel-label': {
                                        fontFamily: 'Inter Bold',
                                        color:
                                            productsAtThisStepNumber(el, cartItems) > 0
                                                ? '#181436'
                                                : 'inherit',
                                    },
                                }}


                            >
                                <div style={{ fontFamily: productsAtThisStepNumber(el, cartItems) > 0 ? 'Inter Bold' : 'Inter Medium', fontSize: '16px' }}>
                                    {`${TextTransformation(el)} ( Choose ${allowedProducts} )`}
                                </div>
                            </StepLabel>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    pl: isMobile ? 0.5 : 1,
                                    // pb: 2,
                                    zIndex: 0,
                                }}
                            >
                                {ProductListObject[el]?.map((product) => {
                                    const ProdCardWidth = () => ['main_dish', 'starters_and_sides', 'desserts_and_drinks', 'kids', 'kids_menu', 'party_pack', 'side', 'complementry', 'promotional'].includes(product?.product_category);
                                    return <Box key={product.product_name} sx={{ width: isMobile ? ProdCardWidth() ? '48%' : '100%' : 'auto', }}>
                                        <ProductCard product={product} mealType={mealType} />
                                    </Box>
                                })}
                            </Box>
                        </Step>
                    )
                })}
            </Stepper>
        </Box>
    );
};

export default ProductVerticalStepper;